/* ==========================================================================
   Pickle Kitchen — pk-v2.js
   Paddle Spotlight: tab switching, crossfading image, animated spec meters,
   auto-rotate with pause on hover/focus/touch. Motion gated behind
   prefers-reduced-motion. Additive — safe to delete with pk-v2.css.
   ========================================================================== */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-pk-spotlight]').forEach(function (spot) {
    var tabs = Array.prototype.slice.call(spot.querySelectorAll('.pk-spot-tab'));
    if (!tabs.length) return;
    var img = spot.querySelector('[data-spot-img]');
    var name = spot.querySelector('[data-spot-name]');
    var desc = spot.querySelector('[data-spot-desc]');
    var price = spot.querySelector('[data-spot-price]');
    var link = spot.querySelector('[data-spot-link]');
    var fills = spot.querySelectorAll('.pk-fill');
    var vals = spot.querySelectorAll('.pk-val');
    var current = -1;
    var timer = null;
    var started = false;

    function setMeters(tab, animate) {
      fills.forEach(function (f) {
        var k = f.getAttribute('data-k');
        var v = tab.getAttribute('data-' + k) || '0';
        if (!animate) f.style.transition = 'none';
        f.style.width = '0%';
        void f.offsetWidth;
        if (!animate) f.style.transition = '';
        f.style.width = v + '%';
      });
      vals.forEach(function (el) {
        el.textContent = tab.getAttribute('data-' + el.getAttribute('data-v')) || '';
      });
    }

    function goTo(i, animate) {
      if (i === current) return;
      current = i;
      var tab = tabs[i];
      tabs.forEach(function (t, idx) {
        t.classList.toggle('active', idx === i);
        t.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      if (img) {
        if (animate && !reduceMotion) {
          img.classList.add('pk-leaving');
          setTimeout(function () {
            img.src = tab.getAttribute('data-img');
            img.alt = tab.getAttribute('data-full-name') || '';
            img.classList.remove('pk-leaving');
          }, 220);
        } else {
          img.src = tab.getAttribute('data-img');
          img.alt = tab.getAttribute('data-full-name') || '';
        }
      }
      if (name) name.textContent = tab.getAttribute('data-full-name') || '';
      if (desc) desc.textContent = tab.getAttribute('data-desc') || '';
      if (price) price.textContent = tab.getAttribute('data-price') || '';
      if (link) link.setAttribute('href', tab.getAttribute('data-url') || '#');
      setMeters(tab, animate && !reduceMotion);
    }

    function startAuto() {
      if (reduceMotion || tabs.length < 2) return;
      stopAuto();
      timer = setInterval(function () {
        goTo((current + 1) % tabs.length, true);
      }, 6000);
    }
    function stopAuto() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        goTo(idx, true);
        startAuto();
      });
    });
    spot.addEventListener('mouseenter', stopAuto);
    spot.addEventListener('mouseleave', startAuto);
    spot.addEventListener('focusin', stopAuto);
    spot.addEventListener('touchstart', stopAuto, { passive: true });

    goTo(0, false);

    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !started) {
              started = true;
              setMeters(tabs[current], true);
              startAuto();
              io.unobserve(spot);
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(spot);
    } else {
      setMeters(tabs[current], false);
    }
  });
})();
